import styled, { css } from "styled-components";
import { FillParent } from "../../layout";

const getZIndex = (isOver: boolean) => {
    if (isOver) {
        return css`
            z-index: 20;
        `;
    } else {
        return css`
            z-index: 10;
        `;
    }
};

const getHoverState = (isOver: boolean) => {
    if (isOver) {
        return css`
            transform: scale(0.9);
            opacity: 1;
        `;
    } else {
        return css`
            transform: scale(1);
            opacity: 0;
        `;
    }
};

export const Wrapper = styled.div<{ isOver: boolean }>`
    ${FillParent}
    width: 100%;
    height: 100%;
    ${({ isOver }) => getZIndex(isOver)}
`;

/**
 * Hidden input
 */
export const Input = styled.input`
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
`;

export const InputLabel = styled.label<{ isOver: boolean }>`
	${FillParent}
	z-index: 1;
	margin: 0 !important;
	cursor: pointer;
	position: relative;

	:after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,.1);
		transition: opacity .35s ease-out, transform .35s ease-out;
		${({ isOver }) => getHoverState(isOver)}}
	}
`;
